import styled from "styled-components";
import {MEDIA_QUERIES} from "constants/StyleConstants.js";
import {StyleButtonRound} from "components/Common/StyleButton";
import {ws} from "styles/tokens";

// The margin is a prop, not CSS: RippleButton moves it onto the wrapper that
// clips the button's rounded shape.
export const SignInButton = styled(StyleButtonRound).attrs(() => ({
  type: "submit",
  margin: "50px 0px 0px 0px"
}))`
  width: 300px;
  height: 50px;
  background-color: ${ws.accent};
  font-weight: 600;

  @media only screen and (min-width: ${MEDIA_QUERIES.tablet_min_width}) and (max-width: ${MEDIA_QUERIES.tablet_max_width}) {
    width: 450px;
    height: 70px;
    border-radius: ${ws.radiusPill};
    font-size: 1.1rem;
  }
`;

export const SignUpButton = styled(StyleButtonRound).attrs(() => ({
  type: "submit",
  margin: "50px 0px 0px 0px"
}))`
  width: 300px;
  height: 50px;
  background-color: ${ws.fg};
  color: ${ws.bg};
  font-weight: 600;

  @media only screen and (min-width: ${MEDIA_QUERIES.tablet_min_width}) and (max-width: ${MEDIA_QUERIES.tablet_max_width}) {
    width: 450px;
    height: 70px;
    border-radius: ${ws.radiusPill};
    font-size: 1.1rem;
  }
`;
